import { Button, Col, FormControl, FormLabel, FormSelect, Row, Spinner } from "react-bootstrap";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa";
import defaultAvatar from '../../../user.png';
import { useEffect, useState } from "react";
import Validator from "../../../services/Validator";
import PrivateApi from "../../../services/PrivateApiService";
import AreYouSureModal from "../AreYouSureModal";
import IbanField from "../IbanField";

const ProfileView = ({ user }) => {

    const API = new PrivateApi();
    const VALIDATOR = new Validator();
    const [view, setView] = useState("form");
    const [profileImageView, setProfileImageView] = useState("default");
    const [profileImage, setProfileImage] = useState(user.image_1920);
    const [profileImgToBig, setProfileImageToBig] = useState(false);
    const [data, setData] = useState(user);
    const [isLoading, setIsLoading] = useState(false);
    const [areYouSure, setAreYouSure] = useState(false);
    const [sendBtnHidden, setSendBtnHidden] = useState(true);


    useEffect(() => {
        if (hasDataChanged()) {
            setSendBtnHidden(false);
        }
        else {
            setSendBtnHidden(true);
        }
    }, [data, user]);



    const hasDataChanged = () => {
        const keysA = Object.keys(data).filter(k => k !== "image_1920");
        const keysB = Object.keys(user).filter(k => k !== "image_1920");


        if (keysA.length !== keysB.length) return true;

        for (let key of keysA) {
            if (key === "x_account_iban" && user[key] !== data[key]) {                
                if (VALIDATOR.ibanValid(data[key])) return true;
                else return false;
            }
            if (key === "x_account_bic" && user[key] === "False" && data[key] === "") return false;
            if (user[key] !== data[key]) return true;
        }
        return false;
    }


    const getBase64 = (file) => {
        setProfileImageToBig(false);
        setProfileImageView("loading");

        if (file.size > 8 * 1024 * 1024) {
            setProfileImageView("default");
            return setProfileImageToBig(true);
        }

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setProfileImage(reader.result.split(",")[1]);
            setData(prev => ({ ...prev, image_1920: reader.result.split(",")[1] }));
            API.post_PartnerImage({ image: reader.result.split(",")[1] })
                .then(() => {
                    setProfileImageView("uploaded");
                })
            return reader.result.split(",")[1];
        }
    }

    const deleteProfileImage = () => {
        setProfileImageView("loading");
        setAreYouSure(false);
        API.post_PartnerImage({ delete: true })
            .then(() => {
                setProfileImageView("uploaded");
                setProfileImage("False");
            });
    }
    
    const downloadFile = (b64, fileName) => {
        const linkSource = `data:application/pdf;base64,${b64}`;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    
    const changeData = () => {
        setIsLoading(true);
        var temp = {};

        if (data.x_anrede === "") temp.x_anrede = "Dieses Feld ist erforderlich";
        if (data.name === "") temp.name = "Dieses Feld ist erforderlich";
        if (!VALIDATOR.olderThan18(data.x_birthdate)) temp.x_birthdate = "Sie müssen mindestens 18 Jahre alt sein.";
        if (!VALIDATOR.EmailValid(data.email)) temp.email = "Ungültige E-Mail-Adresse";

        var dataToSend = {};
        for (const [key, value] of Object.entries(data)) {
            if (data[key] !== user[key]) dataToSend[key] = value
        }
        if (Object.keys(dataToSend).length > 0) {
            API.post_UserUpdate(dataToSend)
                .then(() => {setView("saved"); setIsLoading(false)})
                .catch(() => {setView("error"); setIsLoading(false)});
        }
    }

    const setIban = (iban) => {
        setData(prev => ({ ...prev, x_account_iban: iban }));
    }

    if (view === "error") return (
        <div className="text-center">
            <Row>
                <Col>
                    <FaExclamationCircle className="text-danger" size={50} />
                </Col>
            </Row>
            <Row className="mt-3">
                <p>Fehler aufgetreten, bitte versuchen Sie später erneut.</p>
            </Row>
        </div>
    )


    if (view === "saved") return (
        <div className="text-center">
            <Row>
                <Col>
                    <FaCheckCircle className="text-energo" size={50}/>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <p>
                        Die von Ihnen geänderten Daten wurden an <b className="text-energo">ENERGO</b> übermittelt.
                        Die Anpassung der Daten erfolgt in Kürze. Bei Unklarheiten kommen wir auf Sie zurück.
                    </p>
                </Col>
            </Row>
        </div>
    )

    if (view === "form") return (
        <>
            <Row>
                <Col xl="12">
                    <h5>Kundendaten</h5>
                    <p className="text-muted">Hier können Sie Ihre Stammdaten anpassen</p>
                    <hr />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <p>Kundennummer: <b>{data.x_poolmember_seqnr}</b></p>
                </Col>
            </Row>
            <Row className="mt-3 align-items-center">
                <Col xl="6" className="text-start">
                    <div style={{display: "flex"}}>
                        {
                            profileImageView === "default"?
                                <>
                                    <img
                                        src={profileImage && profileImage !== "False" ? 'data:image/jpeg;base64,' + profileImage : defaultAvatar}
                                        alt="Profilbild"
                                        className="img-fluid"
                                        style={{ maxHeight: "80px" }}
                                    />
                                    <div style={{marginTop: "auto", marginBottom: "auto", marginLeft: 5}}>
                                        <a
                                            href="profileBild/upload/"
                                            className="link-energo"
                                            onClick={e => { e.preventDefault(); document.getElementById('profilePicField').click() }}
                                        >
                                            Profilbild ändern
                                            {profileImgToBig === true ?
                                                <p className="text-danger"><small>Bild darf nicht größer sein als 8 MB.</small></p>
                                                : null
                                            }
                                        </a>
                                        <br />
                                        {profileImage !== "False" && profileImage !== ""?
                                            <a
                                                href="link-energo text-danger"
                                                className="link-energo text-danger"
                                                onClick={e => { e.preventDefault(); setAreYouSure(true) }}
                                            >
                                                Profilbild löschen
                                            </a>
                                        :null
                                        }
                                    </div>
                                </>:
                            profileImageView === "loading"?
                                <Spinner className="text-energo" animation="border"/> :

                            profileImageView === "uploaded"?
                                <p>Profilbild ist geändert!</p>
                            
                            :null
                        }
                        <input
                            type="file"
                            name="profilePicField"
                            id="profilePicField"
                            hidden
                            accept="image/*"
                            onChange={e => getBase64(e.target.files[0])} 
                        />

                    </div>
                </Col>

                <Col xl="6" className="text-end">
                    <a
                        href="#vollmacht/ansehen"
                        className="link-energo"
                        onClick={e => { e.preventDefault(); downloadFile(data.x_file_vollmacht, data.x_file_vollmacht_name) }}
                    >
                        Vollmacht Download
                    </a>
                    <br />
                    <a
                        hidden={data.x_file_ausweiskopie === undefined || data.x_file_ausweiskopie === "False"}
                        href="#ausweis/ansehen"
                        className="link-energo"
                        onClick={e => { e.preventDefault(); downloadFile(data.x_file_ausweiskopie, `Ausweis-${data.name}.pdf`) }}
                    >
                        Ausweis Download
                    </a>
                </Col>
            </Row >
            {
                data.company_type === "person" ?
                    <Row className="mt-5">
                        <Col xs="6" md="6" xl="4">
                            <FormLabel>Anrede</FormLabel>
                            <FormSelect defaultValue={data.x_anrede} onChange={e => setData(prev => ({ ...prev, x_anrede: e.target.value }))}>
                                <option value="Herr">Herr</option>
                                <option value="Frau">Frau</option>
                                <option value="Keine Angabe">Keine Angabe</option>
                            </FormSelect>
                        </Col>
                        <Col xs="6" md="6" xl="4">
                            <FormLabel>Titel</FormLabel>
                            <FormSelect defaultValue={data.title} onChange={e => setData(prev => ({ ...prev, title: e.target.value }))}>
                                <option value="0"></option>
                                <option value="15">DDr.</option>
                                <option value="16">DI</option>
                                <option value="17">DI (FH)</option>
                                <option value="31">DI Dr.</option>
                                <option value="51">Dipl. Päd.</option>
                                <option value="18">Dipl. WI (FH)</option>
                                <option value="19">Dipl.-Ing.</option>
                                <option value="30">Dipl.-Ing. Dr.</option>
                                <option value="25">Dr.</option>
                                <option value="8">Ing.</option>
                                <option value="37">Ing. Mag.</option>
                                <option value="6">Mag.</option>
                                <option value="23">Mag. (FH)</option>
                                <option value="24">Mag. Dr.</option>
                                <option value="32">Prof.</option>
                                <option value="44">Univ.-Prof Dr.</option>
                            </FormSelect>
                        </Col>
                    </Row>
                    : null
            }
            < Row className={data.company_type === "person" ? "mt-3" : "mt-5"} >
                <Col xs="12" md="10" xl="8">
                    <FormLabel>{data.company_type === "person" ? "Vor- und Nachname" : "Unternehmensbezeichnung"}</FormLabel>
                    <FormControl value={data.name} onChange={e => setData(prev => ({ ...prev, name: e.target.value }))} />
                </Col>
                {
                    data.company_type === "person" ?
                        <Col xs="8" md="6" xl="4">
                            <FormLabel>Titel hinten</FormLabel>
                            <FormControl
                                value={data.x_title_postfix === "False" ? "" : data.x_title_postfix}
                                onChange={e => setData(prev => ({ ...prev, x_title_postfix: e.target.value }))}
                            />
                        </Col>
                        : null
                }
            </Row >
            {
                data.company_type === "company" ?
                    <Row className="mt-3">
                        <Col xs="12" md="6" xl="6">
                            <FormLabel>Firmenbuchnummer</FormLabel>
                            <FormControl
                                value={data.x_firmenbuch_nr}
                                onChange={e => setData(prev => ({ ...prev, x_firmenbuch_nr: e.target.value }))}
                            />
                        </Col>
                        <Col xs="12" md="6" xl="6">
                            <FormLabel>UID</FormLabel>
                            <FormControl value={data.vat} onChange={e => setData(prev => ({ ...prev, vat: e.target.value }))} />
                        </Col>
                    </Row>
                    :

                    <Row className="mt-3">
                        <Col xs="12" md="8" xl="4">
                            <FormLabel>Geburtsdatum</FormLabel>
                            <FormControl
                                type="date"
                                value={data.x_birthdate}
                                onChange={e => setData(prev => ({ ...prev, x_birthdate: e.target.value }))}
                            />
                        </Col>
                    </Row>
            }
            < Row className="mt-5" >
                <Col xs="12" md="12" xl="8">
                    <FormLabel>Kontakt E-Mail</FormLabel>
                    <FormControl
                        value={data.email}
                        onChange={e => setData(prev => ({ ...prev, email: e.target.value }))}
                    />
                </Col>
                <Col xs="12" md="6" xl="4">
                    <FormLabel>Telefon</FormLabel>
                    <FormControl
                        value={data.mobile === "False" ? "" : data.mobile}
                        onChange={e => setData(prev => ({ ...prev, mobile: e.target.value }))}
                    />
                </Col>
            </Row >
            <Row className="mt-5">
                <Col xs="12" md="6" xl="6">
                    <FormLabel>Land</FormLabel>
                    <FormSelect
                        defaultValue={data.country_id}
                        onChange={e => setData(prev => ({ ...prev, country_id: e.target.value }))}
                    >
                        <option value="12">Österreich</option>
                        <option value="57">Deutschland</option>
                    </FormSelect>
                </Col>
                <Col xs="12" md="6" xl="6">
                    <FormLabel>Bundensland</FormLabel>
                    <FormSelect
                        defaultValue={data.state_id}
                        onChange={e => setData(prev => ({ ...prev, state_id: e.target.value }))}
                    >
                        <option value=""></option>
                        <option value="1436">Burgenland</option>
                        <option value="1437">Kärnten</option>
                        <option value="1438">Niederösterreich</option>
                        <option value="1439">Oberösterreich</option>
                        <option value="1440">Salzburg</option>
                        <option value="1441">Steiermark</option>
                        <option value="1442">Tirol</option>
                        <option value="1443">Vorarlberg</option>
                        <option value="1444">Wien</option>
                    </FormSelect>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12" md="4" xl="2">
                    <FormLabel>PLZ</FormLabel>
                    <FormControl value={data.zip} onChange={e => setData(prev => ({ ...prev, zip: e.target.value }))} />
                </Col>
                <Col xs="12" md="8" xl="6">
                    <FormLabel>Ort</FormLabel>
                    <FormControl value={data.city} onChange={e => setData(prev => ({ ...prev, city: e.target.value }))} />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12" md="10" xl="8">
                    <FormLabel>Straße</FormLabel>
                    <FormControl value={data.street} onChange={e => setData(prev => ({ ...prev, street: e.target.value }))} />
                </Col>
            </Row>
            <Row className="mt-5">
                <Col xs="12" md="10" xl="8">
                    <FormLabel>Kontoinhaber</FormLabel>
                    <FormControl value={data.x_account_owner} onChange={e => setData(prev => ({ ...prev, x_account_owner: e.target.value }))} />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12" md="6" xl="4">
                    <FormLabel>BIC</FormLabel>
                    <FormControl value={data.x_account_bic === "False"? "":data.x_account_bic} onChange={e => setData(prev => ({ ...prev, x_account_bic: e.target.value }))} />
                </Col>
                <Col xs="12" md="10" xl="8">
                    <FormLabel>IBAN</FormLabel>
                    <IbanField x_account_iban={data.x_account_iban} setIban={setIban} />
                </Col>
            </Row>
            <Row className="mt-5">
                <Col className="text-end">
                    {
                        isLoading?
                            <Spinner animation="border" className="text-energo" />
                        :
                        <Button hidden={sendBtnHidden} onClick={() => changeData()} className="btn-energo">Absenden</Button>
                    }
                </Col>
            </Row>
            <AreYouSureModal
                show={areYouSure}
                setShow={setAreYouSure}
                title="Profilbild löschen"
                message="Sind Sie sicher das Sie Profilbild löschen wollen?"
                yesHandler={deleteProfileImage}
                loading={false}
            />
        </>
    )
}
export default ProfileView;